<app-page-wrapper>
  <app-loading-spinner *ngIf="!account || !organizations;else main_content"></app-loading-spinner>
  <ng-template #main_content>

    <div class="my-4" *ngIf="!isMyAccount">
      <span class="link breadcrumb-link" (click)="goBack()">
        <i class="far fa-angle-left"></i> Back
      </span>
    </div>

    <div class="d-flex header my-4">
      <app-profile-picture class="mr-3 large" [name]="account.Name"></app-profile-picture>
      <div class="w-100">
        <div class="d-flex align-items-end">
          <h1 class="m-0 mr-2">
            {{ editObj === account ? 'Edit Account' : account.Name }}
          </h1>
          <span *ngIf="editObj !== account && account.ExternalID">#{{ account.ExternalID }}</span>
          <div class="ml-auto d-flex align-self-start">
            <ng-container *ngIf="!sendingWelcomeEmail">
              <ng-container *ngIf="!editObj && !deleteObj">
                <span (click)="sendWelcomeEmail(account.ID)" *ngIf="!isMyAccount || authService.isSuper()" class="ml-4" ngbTooltip="Resend Welcome Email">
                  <i class="fal fa-envelope pointer"></i>
                </span>
                <span *ngIf="isMyAccount || authService.isSuper() || authService.isAdmin()" class="ml-4" (click)="startEditObj($event, account)" ngbTooltip="Edit Account">
                  <i class="fal fa-pencil-alt pointer"></i>
                </span>
                <span *ngIf="authService.isSuper() && !isMyAccount" class="ml-4" (click)="deleteAccount()" ngbTooltip="Delete Account">
                  <i class="fal fa-trash-alt pointer"></i>
                </span>
              </ng-container>
            </ng-container>
            <span *ngIf="deleteObj === account || (saving && editObj === account) || sendingWelcomeEmail">
              <i class="fal fa-spinner fa-spin"></i>
            </span>
            <span (click)="updateAccount()" *ngIf="!saving && editObj" ngbTooltip="Save">
              <i class="fal fa-save pointer"></i>
            </span>
            <span (click)="cancelEditObj($event, account)" *ngIf="!saving && editObj && account.ID"
              class="ml-4" ngbTooltip="Cancel">
              <i class="fal fa-times pointer"></i>
            </span>
          </div>
        </div>
        <ng-container *ngIf="editObj !== account">{{ account.Email }}</ng-container>
        <div *ngIf="editObj === account" class="row mt-3">
          <div class="form-group col-md-6">
            <label for="user-name">Name</label>
            <input id="user-name" class="form-control" [(ngModel)]="editObj.Name" disabled="{{ saving }}">
          </div>
          <div class="form-group col-md-6">
            <label for="user-id">ID</label>
            <input id="user-id" class="form-control" [(ngModel)]="editObj.ExternalID" disabled="{{ saving }}">
          </div>
          <div class="form-group col-md-6">
            <label for="email">Email</label>
            <input id="email" class="form-control" [(ngModel)]="editObj.Email" disabled="{{ saving }}">
          </div>
          <!-- <div class="form-group col-md-4">
            <label for="current-password">Current Password</label>
            <input id="current-password" class="form-control" disabled="{{ saving }}">
          </div> -->
          <div *ngIf="authService.isSuper()" class="form-group col-md-6">
            <label for="new-password">New Password</label>
            <input id="new-password" class="form-control" [(ngModel)]="editObj.Password" disabled="{{ saving }}">
          </div>
          <div class="form-group col-md-4">
            <label for="confirm-password">Change Password</label>
            <input id="confirm-password" class="form-control" [(ngModel)]="account.Password" disabled="{{ saving }}">
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="organizations.length && editObj !== account">
      <button class="btn btn-filter btn-selected my-2">
        <i class="fas fa-sitemap"></i>
        Organizations
      </button>

      <table class="table">
        <thead>
          <th>Name</th>
          <th>ID</th>
          <th>Type</th>
          <th>Role</th>
          <!-- <th></th> -->
        </thead>
        <tbody>
          <tr *ngFor="let obj of organizations" [class.editing]="editObj === obj" [class.hover]="editObj !== obj && deleteObj !== obj"
            (click)="goToOrg(obj)">
            <td>
              <a [routerLink]="getOrgRouterLink(obj)" [queryParams]="getOrgRouterQueryParams(obj)" *ngIf="editObj !== obj">{{ obj.Description }}</a>
            </td>
            <td>
              <span *ngIf="editObj !== obj">{{ obj.ExternalID }}</span>
            </td>
            <td>{{ getOrganizationType(obj) }}</td>
            <td>{{ rolesMap && rolesMap[obj.RoleCode] }}</td>
            <!-- <td class="icon">
              <span (click)="$event.stopPropagation(); deleteAdministrator(obj)" *ngIf="deleteObj !== obj" ngbTooltip="Delete">
                <i class="fal fa-trash-alt pointer"></i>
              </span>
              <span *ngIf="deleteObj === obj">
                <i class="fal fa-spinner fa-spin"></i>
              </span>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>

  </ng-template>
</app-page-wrapper>
